module.exports = "../images/fishing-lodge-01.jpg?v=fcd7034";